import React, { useState } from 'react';
import { TextField, Button, FormControlLabel, Checkbox, Container, Typography, Snackbar, Alert } from '@mui/material';
import axios from 'axios';

const ReportForm = () => {
  const [formData, setFormData] = useState({
    incidentType: '',
    date: '',
    time: '',
    location: '',
    description: '',
    isAnonymous: false,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value, checked } = e.target;
    setFormData({
      ...formData,
      [name]: name === 'isAnonymous' ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      // Prepare payload
      const payload = {
        incidentType: formData.incidentType,
        date: formData.date,
        time: formData.time,
        location: formData.location,
        description: formData.description,
        isAnonymous: formData.isAnonymous,
      };
      console.log('Submitting payload from femizero.samzdixon.tech/report:', payload);

      // Send data to the backend
      const response = await axios.post('https://femizero.samzdixon.tech/api/reports', payload, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      console.log('Response:', response.data);

      // Clear the form
      setFormData({
        incidentType: '',
        date: '',
        time: '',
        location: '',
        description: '',
        isAnonymous: false,
      });

      setSuccess(true);
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to submit report. Please check your network and try again.';
      console.error('Error submitting report:', errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
        Report Incident
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Incident Type"
          name="incidentType"
          value={formData.incidentType}
          onChange={handleChange}
          margin="normal"
          size="small"
          required
        />
        <TextField
          fullWidth
          label="Date"
          type="date"
          name="date"
          value={formData.date}
          onChange={handleChange}
          margin="normal"
          InputLabelProps={{ shrink: true }}
          size="small"
          required
        />
        <TextField
          fullWidth
          label="Time"
          type="time"
          name="time"
          value={formData.time}
          onChange={handleChange}
          margin="normal"
          InputLabelProps={{ shrink: true }}
          size="small"
          required
        />
        <TextField
          fullWidth
          label="Location"
          name="location"
          value={formData.location}
          onChange={handleChange}
          margin="normal"
          size="small"
          required
        />
        <TextField
          fullWidth
          label="Description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          margin="normal"
          multiline
          rows={4}
          size="small"
          required
        />
        <FormControlLabel
          control={
            <Checkbox
              name="isAnonymous"
              checked={formData.isAnonymous}
              onChange={handleChange}
            />
          }
          label="Report Anonymously"
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          sx={{ color: 'white' }}
          disabled={loading}
        >
          {loading ? 'Submitting...' : 'Submit'}
        </Button>
      </form>

      {/* Success Message */}
      <Snackbar
        open={success}
        autoHideDuration={6000}
        onClose={() => setSuccess(false)}
      >
        <Alert onClose={() => setSuccess(false)} severity="success">
          Report submitted successfully!
        </Alert>
      </Snackbar>

      {/* Error Message */}
      <Snackbar
        open={!!error}
        autoHideDuration={6000}
        onClose={() => setError(null)}
      >
        <Alert onClose={() => setError(null)} severity="error">
          {error}
        </Alert>
      </Snackbar>

    </Container>
  );
};

export default ReportForm;